import {getMethod} from '@/api'

async function get(params) {
    return await getMethod('/api/printRevise', params, null, {responseType: 'arraybuffer'})
}

export {get}
